module.exports = __webpack_public_path__ + "static/media/selectedplanextended.79da46a2.PNG";